import React from "react";
import { Container } from "@mui/material";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import Settlement from "./settlement";

const PayoutSettlement = () => {
  return (
    <Container>
      <HeaderHelpPage title="Payout Settlement" />
      <Settlement />
    </Container>
  );
};

export default PayoutSettlement;